<template>
    <div>
        <loading
            :active="loading"
            is-full-screen
            spinner="bar-fade-scale"
            color="#6495ED"
        />
        <div class="filter-container">
            <div class="left-content">
                <div class="left-content">
                    <!-- Date Filter -->
                    <passport-date-filter
                        ref="dateFilter"
                        :program-start-date="programStartDate"
                        :program-end-date="programEndDate"
                        :selected-year-from-main-page="selectedYearFromMainPage"
                        :date-from-other-tab="dateFromOtherTab"
                        :is-from-main-page="isFromMainPage"
                        @dateChanged="onDateChanged"
                    />
                </div>
            </div>
            <div class="right-content">
                <div class="filter-actions">
                    <b-button variant="default icon-left" @click="closeAddEdit"><i class="icon icon-keyboard icon-rotate-180"></i>
                        Назад к списку
                    </b-button>
                    <b-button variant="success" @click="save()" :disabled="isReadOnlyMode">Сохранить</b-button>
                </div>
            </div>
        </div>
        <div class="form-card initial-form-passport">
            <div class="passport-item h-60">
                <div class="title">
                    <span>Наименование</span>
                </div>
                <div class="content once">
                    <b-form-input type="text" style="text-transform: uppercase; font-weight: bold; color: rgb(5 48 83); font-size: unset;" v-model="programPassportName" disabled></b-form-input>
                </div>
            </div>
            <div class="passport-item">
                <div class="title">
                    <span>Основание для разработки</span>
                </div>
                <div class="content table-content">
                    <div
                        class="table-style"
                        :class="{ 'has-error': npaElement.hasError }"
                        :key="`npaIndex_${npaIndex}`"
                        v-for="(npaElement, npaIndex) of dictNpaArr"
                    >
                        <div class="w-50">{{ npaIndex+1 }}</div>
                        <div class="full" style="padding-top: 6px; display: block">
                            <multiselect
                                v-model="npaElement.npa"
                                track-by="id"
                                label="name"
                                :value='value'
                                :disabled="npaElement.disabled || isReadOnlyMode"
                                :class="{ 'error-field': npaElement.hasError }"
                                placeholder="Выбрать ..."
                                :options="dictNpaList"
                                :searchable="true"
                                :allow-empty="false"
                                :show-labels="false"
                                :multiple="false"
                                :max-height="300"
                                :option-height="60"
                                @input="chgNpa(npaElement, npaIndex)"
                            >
                                <template slot="singleLabel" slot-scope="{ option }">
                                    <template v-if="option && option.name !== undefined">
                                        <div class="multiselect-single-content">
                                            {{ option.name }}
                                        </div>
                                    </template>
                                </template>

                                <template slot="option" slot-scope="{ option }">
                                    <div class="multiselect-option-content">
                                        {{ option.name }}
                                    </div>
                                </template>
                            </multiselect>
                        </div>
                        <div class="w-50">
                            <b-dropdown
                                v-if="npaElement.npa || !npaElement.disabled"
                                id="dropdown-dropleft"
                                dropleft
                                class="more"
                                :disabled="isReadOnlyMode || isProgramPassportExpired"
                            >
                                <template v-slot:button-content>
                                    <i class="icon icon-more"></i>
                                </template>
                                <template>
                                    <b-dropdown-item
                                        v-if="npaElement.npa"
                                        @click="editRowForMeaningOfDev(npaElement, npaIndex)"
                                        :disabled="isProgramPassportExpired"
                                    >
                                        Редактировать
                                    </b-dropdown-item>
                                    <b-dropdown-item
                                        @click="npaElement.npa ? deleteMeaningRow(npaElement, npaIndex) : removeUnsavedNpa(npaIndex)"
                                        :disabled="isProgramPassportExpired"
                                    >
                                        Удалить
                                    </b-dropdown-item>
                                </template>
                            </b-dropdown>
                        </div>
                    </div>

                    <template v-if="!isProgramPassportExpired">
                        <b-link
                            @click="!isProgramPassportExpired ? addRowForMeaningOfDev() : null"
                            class="add-link"
                            :class="{ 'disabled': isReadOnlyMode || isProgramPassportExpired }"
                        >
                            <i class="icon icon-plus-circle add-button"></i>
                            <span>Добавить</span>
                        </b-link>
                    </template>
                </div>
            </div>
            <div class="passport-item">
                <div class="title">
                    <span>Сроки реализации</span>
                </div>
                <div class="content once">
                    <b-form-input type="text" v-model="programPassportDates" disabled></b-form-input>
                </div>
            </div>
            <div class="passport-item">
                <div class="title">
                    <span>Цели</span>
                </div>
                <div class="content table-content">
                    <div
                        class="table-style"
                        :class="{ 'has-error': goalsElement.hasError }"
                        :key="`goalsIndex_${goalsIndex}`"
                        v-for="(goalsElement, goalsIndex) of dictGoalsArr"
                    >
                        <div class="w-50">{{ goalsIndex+1 }}</div>
                        <div class="full" style="padding-top: 6px; display: block">
                            <multiselect
                                v-model="goalsElement.goals"
                                track-by="id"
                                label="name"
                                :disabled="goalsElement.disabled || isReadOnlyMode"
                                :class="{ 'error-field': goalsElement.hasError }"
                                placeholder="Выбрать цель..."
                                :options="dictProgramPassportGoals"
                                :searchable="true"
                                :allow-empty="true"
                                :show-labels="false"
                                :multiple="false"
                                :max-height="300"
                                :option-height="60"
                                @input="chgPrgGoals({ goals: $event }, goalsIndex)"
                            >
                                <template slot="singleLabel" slot-scope="{ option }">
                                    <template v-if="option && option.name !== undefined">
                                        <div class="multiselect-single-content">
                                            {{ option.name }}
                                        </div>
                                    </template>
                                </template>

                                <template slot="option" slot-scope="{ option }">
                                    <div class="multiselect-option-content">
                                        {{ option.name }}
                                    </div>
                                </template>
                            </multiselect>
                        </div>

                        <div class="w-50">
                            <b-dropdown
                                v-if="goalsElement.goals || !goalsElement.disabled"
                                id="dropdown-dropleft"
                                dropleft
                                class="more"
                                :disabled="isReadOnlyMode || isProgramPassportExpired"
                            >
                                <template v-slot:button-content>
                                    <i class="icon icon-more"></i>
                                </template>
                                <template>
                                    <b-dropdown-item
                                        v-if="goalsElement.goals"
                                        @click="editRowForGoalsOfDev(goalsElement, goalsIndex)"
                                        :disabled="isProgramPassportExpired"
                                    >
                                        Редактировать
                                    </b-dropdown-item>
                                    <b-dropdown-item
                                        @click="goalsElement.goals ? deleteGoalsRow(goalsElement, goalsIndex) : removeUnsavedGoal(goalsIndex)"
                                        :disabled="isProgramPassportExpired"
                                    >
                                        Удалить
                                    </b-dropdown-item>
                                </template>
                            </b-dropdown>
                        </div>
                    </div>

                    <template v-if="!isProgramPassportExpired">
                        <b-link
                            @click="!isProgramPassportExpired ? addRowForGoalsOfDev() : null"
                            class="add-link"
                            :class="{ 'disabled': isReadOnlyMode || isProgramPassportExpired }"
                        >
                            <i class="icon icon-plus-circle add-button"></i>
                            <span>Добавить</span>
                        </b-link>
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import store from "@/services/store";
import axios from "axios";
import Multiselect from 'vue-multiselect'
import VueElementLoading from 'vue-element-loading';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import PassportDateFilter from './PassportDateFilter.vue';

export default {
    name: "PassportOfProgram",
    components: {
        'multiselect': Multiselect,
        'loading': VueElementLoading,
        'passport-date-filter': PassportDateFilter
    },
    async beforeRouteLeave(to, from, next) {
        const isTabChange = to.path === from.path;

        if (isTabChange) {
            next();
            return;
        }

        const hasChanges = this.hasUnsavedChanges();

        if (hasChanges) {
            const confirmed = await this.$bvModal.msgBoxConfirm(
                'Внесенные изменения будут потеряны!',
                {
                    title: 'Несохраненные изменения',
                    size: 'md',
                    buttonSize: 'sm',
                    okVariant: 'warning',
                    okTitle: 'Продолжить',
                    cancelTitle: 'Отмена',
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    centered: true
                }
            );

            if (confirmed) {
                this.cleanupUnsavedChanges();
                this.removeBrowserNavigationProtection();
                next();
            } else {
                next(false);
            }
        } else {
            next();
        }
    },
    mounted() {
        this.getObl();
        this.showDictProgramGoalsList();
        this.$watch('currentProgramPassport.programPassportId', this.setParams);
        this.addBrowserNavigationProtection();
    },
    beforeDestroy() {
        this.removeBrowserNavigationProtection();
    },
    props: {
        value: {
            type: String,
            required: false,
            default: ''
        },
        goalval: {
            type: String,
            required: false,
            default: ''
        },
        currentProgramPassport: {
            required: true,
            default: null
        },
        selectedYearFromMainPage: {
            type: Number,
            default: null
        },
        dateFromOtherTab: {
            type: String,
            default: null
        },
        isFromMainPage: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            currentYear: new Date().getFullYear(),
            currentMonth: new Date().getMonth(),
            currentDay: new Date().getDay(),
            dictNpaList: [],
            obl: '',
            region: '',
            loading: false,
            dictProgramPassportGoals: [],
            listOfGoalsInOrNotInForecast: [],
            dictProgramPassportID: null,
            dictNpaSelectedList: {
                data: []
            },
            dictGoalSelected: {
                data: []
            },
            programId: null,
            initialArrNpa: new Map(),
            initialArrGoal: new Map(),
            selectedDate: null,
            currentVariant: null,
        }
    },
    watch: {
        'dictNpaSelectedList.data': {
            handler(newVal, oldVal) {
                if (!Array.isArray(newVal)) {
                    console.error('dictNpaSelectedList.data is not an array:', newVal);
                    return;
                }
                if (this.dictProgramPassportID && !this.loading) {
                    this.$nextTick(() => {
                        this.emitUnsavedChangesStatus();
                    });
                }
            },
            deep: true
        },

        'dictGoalSelected.data': {
            handler(newVal, oldVal) {
                if (!Array.isArray(newVal)) {
                    console.error('dictGoalSelected.data is not an array:', newVal);
                    return;
                }
                if (this.dictProgramPassportID && !this.loading) {
                    this.$nextTick(() => {
                        this.emitUnsavedChangesStatus();
                    });
                }
            },
            deep: true
        }
    },
    methods: {
        usrId() {
            if (store.state.user.sub === undefined) { return null; }
            return store.state.user.sub;
        },

        addBrowserNavigationProtection() {
            this.beforeUnloadHandler = (event) => {
                if (this.hasUnsavedChanges()) {
                    const message = 'Внесенные изменения будут потеряны!';
                    event.preventDefault();
                    event.returnValue = message;
                    return message;
                }
            };

            window.addEventListener('beforeunload', this.beforeUnloadHandler);

            this.popstateHandler = async (event) => {
                if (this.hasUnsavedChanges()) {
                    history.pushState(null, null, window.location.href);

                    try {
                        const confirmed = await this.$bvModal.msgBoxConfirm(
                            'Внесенные изменения будут потеряны!',
                            {
                                title: 'Несохраненные изменения',
                                size: 'md',
                                buttonSize: 'sm',
                                okVariant: 'warning',
                                okTitle: 'Продолжить',
                                cancelTitle: 'Отмена',
                                footerClass: 'p-2',
                                hideHeaderClose: false,
                                centered: true
                            }
                        );

                        if (confirmed) {
                            this.removeBrowserNavigationProtection();
                            this.cleanupUnsavedChanges();
                            history.back();
                        }
                    } catch (error) {
                        console.error('Error showing confirmation dialog:', error);
                    }
                }
            };

            history.pushState(null, null, window.location.href);
            window.addEventListener('popstate', this.popstateHandler);
        },

        removeBrowserNavigationProtection() {
            if (this.beforeUnloadHandler) {
                window.removeEventListener('beforeunload', this.beforeUnloadHandler);
                this.beforeUnloadHandler = null;
            }

            if (this.popstateHandler) {
                window.removeEventListener('popstate', this.popstateHandler);
                this.popstateHandler = null;
            }
        },

        removeUnsavedNpa(index) {
            this.dictNpaSelectedList.data = this.removeRowByIndex(this.dictNpaSelectedList.data, index);
            this.makeToast('info', 'НПА удален', 'Несохраненная запись удалена');

            this.$nextTick(() => {
                this.emitUnsavedChangesStatus();
            });
        },

        removeUnsavedGoal(index) {
            this.dictGoalSelected.data = this.removeRowByIndex(this.dictGoalSelected.data, index);
            this.makeToast('info', 'Цель удалена', 'Несохраненная запись удалена');

            this.$nextTick(() => {
                this.emitUnsavedChangesStatus();
            });
        },

        emitUnsavedChangesStatus() {
            try {
                const hasChanges = this.hasUnsavedChanges();
                this.$emit('unsavedChangesChanged', hasChanges);
            } catch (error) {
                console.error('Error in emitUnsavedChangesStatus:', error);
            }
        },

        async setParams() {
            this.loading = true;
            const currentProgramPassport = this.currentProgramPassport;

            if (currentProgramPassport === null) {
                this.programPassportName = null;
                this.programPassportDates = null;
                this.dictNpaSelectedList.data = [];
                this.dictGoalSelected.data = [];
                this.currentVariant = null;
            } else {
                this.programId = this.currentProgramPassport.programId;
                this.dictProgramPassportID = currentProgramPassport.programPassportId;

                const filterDate = this.getDefaultFilterDate();

                await this.calculateProgramVariant(filterDate);

                if (this.currentVariant && this.currentVariant.variantUUID) {
                    await this.getPrgPassportNpaAndGoals(this.dictProgramPassportID);
                } else {
                    console.warn('No variant found for date:', filterDate, 'Program:', this.programId);
                    this.dictNpaSelectedList.data = [];
                    this.dictGoalSelected.data = [];
                    this.loading = false;
                }
            }
        },

        getDefaultFilterDate() {
            const currentDate = new Date();
            const currentYear = currentDate.getFullYear();

            let defaultDate;
            if (this.isFromMainPage) {
                if (this.selectedYearFromMainPage === currentYear) {
                    defaultDate = currentDate;
                } else if (this.selectedYearFromMainPage < currentYear) {
                    defaultDate = new Date(this.selectedYearFromMainPage, 11, 31); // December is month 11
                } else {
                    defaultDate = new Date(this.selectedYearFromMainPage, 0, 1); // January is month 0
                }
            } else {
                defaultDate = this.dateFromOtherTab ? new Date(this.dateFromOtherTab) : currentDate;
            }

            const year = defaultDate.getFullYear();
            const month = String(defaultDate.getMonth() + 1).padStart(2, '0');
            const day = String(defaultDate.getDate()).padStart(2, '0');
            return `${year}-${month}-${day}`;
        },

        async calculateProgramVariant(filterDate) {
            if (!this.programId || !filterDate) {
                return null;
            }

            const apiUrl = `/api/program-variant/program/${this.programId}/variant-for-date?date=${filterDate}`;

            try {
                const response = await fetch(apiUrl);

                if (response.ok) {
                    const variant = await response.json();
                    const currentDate = new Date();
                    currentDate.setHours(0, 0, 0, 0);
                    const filterDateObj = new Date(filterDate);
                    filterDateObj.setHours(0, 0, 0, 0);
                    const isHistoricalDate = filterDateObj < currentDate;
                    const isActualVariant = variant.actual === true;
                    this.currentVariant = variant;
                    return variant;
                } else {
                    const errorText = await response.text();
                    this.currentVariant = null;
                    return null;
                }
            } catch (error) {
                console.error("Fetch error: ", error);
                this.currentVariant = null;
                return null;
            }
        },

        // -------Метод для извлечения области и региона-------//
        async getObl() {    // -----Извлекается регион и область из глобальных настроек пользователя
            let region = null;
            let oblast = null;
            try {
                await fetch('/api-py/get-budget-obl/' + store.state._instanceCode)
                    .then(response => response.json())
                    .then(json => {
                        this.obl = json.obl;
                        oblast = json.obl;
                        // this.region = json.region;
                        region = json.region;
                    });
            } catch (error) {
                this.makeToast('danger', 'Ошибка запроса getObl', error.toString());
            }
            // const usr = store.getters.user_uuid;
            const usr = this.userId;
            // console.log('usr: ' + usr);

            // let region = this.region;
            try {
                await fetch('/api-py/get-user-regions-by-obl/' + this.obl + '/' + usr)
                    .then(response => response.json())
                    .then(json => {
                        if (json.length && json[0].code) { region = json[0].code; }
                    });
            } catch (error) {
                this.makeToast('danger', 'Ошибка запроса get-user-budget-region', error.toString());
            }
            this.region = region;
            await this.showDictNpaList(oblast, region);
        },

        padLeadingZeros(num, size) {    // -------добавление нулей после значения в зависимости от размера значения
            let s = num;
            while (s.length < size) { s = s + '0'; }
            return s;
        },

        //-----Извлечь ранее сохраненные записи в БД по ProgramPassportId
        async getPrgPassportNpaAndGoals(prgPassportId) {
            if (!prgPassportId || prgPassportId === "") return;

            this.dictNpaSelectedList.data = [];
            this.dictGoalSelected.data = [];
            this.initialArrNpa.clear();
            this.initialArrGoal.clear();

            const listOfGoalsForChecking = [];

            try {
                let npaUrl = `/api/program-passport/get-program-passport-npa/${prgPassportId}`;
                let goalUrl = `/api/program-passport/get-program-passport-goal/${prgPassportId}`;

                if (this.currentVariant && this.currentVariant.variantUUID) {
                    const variantParam = `?variant=${this.currentVariant.variantUUID}`;
                    npaUrl += variantParam;
                    goalUrl += variantParam;
                }

                const [npaResponse, goalResponse] = await Promise.all([
                    fetch(npaUrl),
                    fetch(goalUrl)
                ]);

                let listNpa = await npaResponse.json();
                let listGoals = await goalResponse.json();

                listNpa = Array.isArray(listNpa) ? listNpa : [];
                listGoals = Array.isArray(listGoals) ? listGoals : [];

                if (listNpa.length > 0) {
                    for (const el of listNpa) {
                        const npaObj = {
                            id: el.dictNpa.id,
                            program_passport_id: this.dictProgramPassportID,
                            dict_npa_id: el.dictNpa.id,
                            npa: el.dictNpa,
                            disabled: true,
                            variant: el.variant
                        };
                        this.dictNpaSelectedList.data.push(this.setNameLangs(npaObj));
                        this.initialArrNpa.set(npaObj.id, JSON.parse(JSON.stringify(npaObj)));
                    }
                }

                if (listGoals.length > 0) {
                    for (const el of listGoals) {
                        const goalsObj = {
                            id: el.dictProgramGoal.id,
                            program_passport_id: this.dictProgramPassportID,
                            dict_program_goal_id: el.dictProgramGoal.id,
                            goals: el.dictProgramGoal,
                            disabled: true,
                            deletable: false,
                            editable: false,
                            variant: el.variant,
                            isFromCurrentVariant: this.currentVariant && el.variant === this.currentVariant.variantUUID
                        };
                        if (el.dictProgramGoal.id) {
                            listOfGoalsForChecking.push(el.dictProgramGoal.id);
                        }
                        this.dictGoalSelected.data.push(this.setNameLangs(goalsObj, 'goals'));
                        this.initialArrGoal.set(goalsObj.id, JSON.parse(JSON.stringify(goalsObj)));
                    }

                    if (listOfGoalsForChecking.length > 0) {
                        await this.getListOfGoalsInForecast(listOfGoalsForChecking);
                    }
                }

                this.loading = false;
            } catch (error) {
                console.error('Error loading data:', error);
                this.makeToast('danger', 'Ошибка загрузки данных', error.toString());
                this.loading = false;
            }
        },

        async getListOfGoalsInForecast(arr) {
            try {
                if (!Array.isArray(arr)) {
                    console.warn('getListOfGoalsInForecast: Expected array, got:', arr);
                    return;
                }

                if (arr.length > 0) {
                    const headers = {
                        'Content-Type': 'application/json'
                    };

                    let url = `/api/program-passport/list-of-goals-in-forecast/${this.programId}`;
                    if (this.currentVariant && this.currentVariant.variantUUID) {
                        url += `?variant=${encodeURIComponent(this.currentVariant.variantUUID)}`;
                    }
                    const result = await axios.post(url, arr, {headers});
                    if (result.status === 200) {
                        const responseData = Array.isArray(result.data) ? result.data : [];
                        if (responseData.length > 0 && this.dictGoalSelected.data.length > 0) {
                            for (const goalsInForecast of responseData) {
                                for (const goals of this.dictGoalSelected.data) {
                                    if (goalsInForecast.dict_program_goals.id === goals.dict_program_goal_id) {
                                        goals.cannotDelete = goalsInForecast.inForecast;
                                        goals.cannotEdit = goalsInForecast.inForecast;
                                        goals.deletable = goalsInForecast.inForecast;
                                        goals.editable = goalsInForecast.inForecast;
                                    }
                                }

                                const goalsArray = Array.isArray(this.dictGoalsArr) ? this.dictGoalsArr : [];
                                for (const goals of goalsArray) {
                                    if (goalsInForecast.dict_program_goals.id === goals.id) {
                                        goals.cannotDelete = goalsInForecast.inForecast;
                                        goals.cannotEdit = goalsInForecast.inForecast;
                                        goals.deletable = goalsInForecast.inForecast;
                                        goals.editable = goalsInForecast.inForecast;
                                    }
                                }
                            }
                        }
                    } else {
                        this.makeToast('danger', 'Сравнение значений цели с таблицей forecast на наличие связи', `Ошибка ${result.status} ${result.statusText}`);
                    }
                }
            } catch (error) {
                console.error('Error checking goals in forecast:', error);
                this.makeToast('danger', 'Ошибка проверки связей целей', 'Произошла ошибка при проверке связей с прогнозными данными');
            }
        },

        //----Добавление новой записи в "Основание для разработки"
        addRowForMeaningOfDev() {
            const npaObj = {
                id: '',
                program_passport_id: this.dictProgramPassportID,
                dict_npa_id: '',
                npa: null,
                disabled: false,
                hasError: false
            }

            this.dictNpaSelectedList.data.push(npaObj);

            this.$nextTick(() => {
                this.emitUnsavedChangesStatus();
            });
        },

        addRowForGoalsOfDev() {
            const goalsObj = {
                id: '',
                program_passport_id: this.dictProgramPassportID,
                dict_program_goal_id: '',
                goals: null,
                disabled: false,
                deletable: false,
                editable: false,
                hasError: false
            }

            this.dictGoalSelected.data.push(goalsObj);

            this.$nextTick(() => {
                this.emitUnsavedChangesStatus();
            });
        },

        //-----Изменение текущей выборки в "Основание для разработки" <multiselect>
        chgNpa(value, npaIndex) {
            if (value !== undefined && value.npa) {
                const selectedNpa = value.npa;

                const existingNpas = this.dictNpaSelectedList.data.filter((_, index) => index !== npaIndex);
                const isDuplicate = existingNpas.some(npa =>
                    npa.dict_npa_id === selectedNpa.id && npa.dict_npa_id !== ''
                );

                if (isDuplicate) {
                    this.$nextTick(() => {
                        this.$set(this.dictNpaSelectedList.data[npaIndex], 'npa', null);
                        this.$set(this.dictNpaSelectedList.data[npaIndex], 'dict_npa_id', '');
                        this.$set(this.dictNpaSelectedList.data[npaIndex], 'id', '');
                    });
                    this.makeToast('danger', 'Дубликат', 'Данная запись уже присутствует');
                    return;
                }

                if (this.dictNpaSelectedList.data[npaIndex] !== undefined) {
                    this.$set(this.dictNpaSelectedList.data[npaIndex], 'id', selectedNpa.id);
                    this.$set(this.dictNpaSelectedList.data[npaIndex], 'program_passport_id', this.dictProgramPassportID);
                    this.$set(this.dictNpaSelectedList.data[npaIndex], 'dict_npa_id', selectedNpa.id);
                    this.$set(this.dictNpaSelectedList.data[npaIndex], 'npa', selectedNpa);
                    this.$set(this.dictNpaSelectedList.data[npaIndex], 'disabled', false);

                    this.$nextTick(() => {
                        this.emitUnsavedChangesStatus();
                    });
                }
            }
        },

        async chgPrgGoals(goalVal, goalsIndex) {
            if (goalVal !== undefined && goalVal.goals) {
                const selectedGoal = goalVal.goals;

                const existingGoals = this.dictGoalSelected.data.filter((_, index) => index !== goalsIndex);
                const isDuplicate = existingGoals.some(goal =>
                    goal.dict_program_goal_id === selectedGoal.id && goal.dict_program_goal_id !== ''
                );

                if (isDuplicate) {
                    this.$nextTick(() => {
                        this.$set(this.dictGoalSelected.data[goalsIndex], 'goals', null);
                        this.$set(this.dictGoalSelected.data[goalsIndex], 'dict_program_goal_id', '');
                        this.$set(this.dictGoalSelected.data[goalsIndex], 'id', '');
                    });
                    this.makeToast('danger', 'Дубликат', 'Данная запись уже присутствует');
                    return;
                }

                if (this.dictGoalSelected.data[goalsIndex] !== undefined) {
                    this.$set(this.dictGoalSelected.data[goalsIndex], 'id', selectedGoal.id);
                    this.$set(this.dictGoalSelected.data[goalsIndex], 'program_passport_id', this.dictProgramPassportID);
                    this.$set(this.dictGoalSelected.data[goalsIndex], 'dict_program_goal_id', selectedGoal.id);
                    this.$set(this.dictGoalSelected.data[goalsIndex], 'goals', selectedGoal);
                    this.$set(this.dictGoalSelected.data[goalsIndex], 'disabled', false);

                    await this.checkSingleGoalInForecast(selectedGoal.id);

                    this.$nextTick(() => {
                        this.emitUnsavedChangesStatus();
                    });
                }
            }
        },


        //----Извлекает объект из массива по id
        getObject(arr, obj){
            if (arr.length > 0){
                for (const el of arr){
                    if (el.id === obj.id) {
                        return el;
                    }
                }
            }
            return obj;
        },

        //-----Удаляет элемент массива по индексу
        removeRowByIndex(arr, indx) {
            const tmpArr = [];
            if (arr.length > 0) {
                for (let i = 0; i < arr.length; i++) {
                    if (i !== indx) {
                        tmpArr.push(arr[i]);
                    }
                }
            }

            return tmpArr;
        },

        editRowForMeaningOfDev(value, indx) {
            this.dictNpaSelectedList.data[indx].disabled = false;

            this.$nextTick(() => {
                this.emitUnsavedChangesStatus();
            });
        },

        async editRowForGoalsOfDev(el, indx) {
            if (el.dict_program_goal_id) {
                try {
                    await this.checkSingleGoalInForecast(el.dict_program_goal_id);
                    await this.$nextTick();

                    const updatedElement = this.dictGoalSelected.data[indx];
                    const isCurrentVariantActual = this.currentVariant && this.currentVariant.actual === true;
                    const hasTargetIndicators = updatedElement.cannotEdit === true || updatedElement.editable === true;

                    if (hasTargetIndicators) {
                        this.makeToast('danger', 'Внимание', 'Редактирование цели программы невозможно при наличии по ней целевых индикаторов');
                        return;
                    }

                    if (!isCurrentVariantActual) {
                        this.makeToast('danger', 'Внимание', 'Редактирование возможно только в актуальной версии программы');
                        return;
                    }

                } catch (error) {
                    console.error('Error during forecast check:', error);
                }
            }

            this.dictGoalSelected.data[indx].disabled = false;

            this.$nextTick(() => {
                this.emitUnsavedChangesStatus();
            });
        },


        async checkSingleGoalInForecast(goalId) {
            if (!goalId || !this.programId) {
                console.error('Missing goalId or programId, skipping forecast check');
                return;
            }

            try {
                const headers = {
                    'Content-Type': 'application/json'
                };

                let url = `/api/program-passport/list-of-goals-in-forecast/${this.programId}`;
                if (this.currentVariant && this.currentVariant.variantUUID) {
                    url += `?variant=${encodeURIComponent(this.currentVariant.variantUUID)}`;
                }
                const result = await axios.post(url, [goalId], {headers});

                if (result.status === 200) {
                    const responseData = Array.isArray(result.data) ? result.data : [];

                    if (responseData.length > 0) {
                        const forecastData = responseData[0];
                        const forecastStatus = forecastData.isInForecast !== undefined ? forecastData.isInForecast : forecastData.inForecast;
                        let goalFound = false;

                        const goalsData = (this.dictGoalSelected && Array.isArray(this.dictGoalSelected.data))
                            ? this.dictGoalSelected.data
                            : [];

                        for (let i = 0; i < goalsData.length; i++) {
                            const goal = goalsData[i];
                            if (goal.dict_program_goal_id === goalId) {
                                goalFound = true;
                                this.$set(goalsData[i], 'cannotDelete', forecastStatus);
                                this.$set(goalsData[i], 'cannotEdit', forecastStatus);
                                this.$set(goalsData[i], 'deletable', forecastStatus);
                                this.$set(goalsData[i], 'editable', forecastStatus);
                                break;
                            }
                        }

                        if (!goalFound) {
                            console.error('❌ Goal not found in dictGoalSelected.data array!');
                        }
                    } else {
                        const goalsData = (this.dictGoalSelected && Array.isArray(this.dictGoalSelected.data))
                            ? this.dictGoalSelected.data
                            : [];

                        for (let i = 0; i < goalsData.length; i++) {
                            const goal = goalsData[i];
                            if (goal.dict_program_goal_id === goalId) {
                                this.$set(goalsData[i], 'cannotDelete', false);
                                this.$set(goalsData[i], 'cannotEdit', false);
                                this.$set(goalsData[i], 'deletable', false);
                                this.$set(goalsData[i], 'editable', false);
                                break;
                            }
                        }
                    }
                } else {
                    console.error('API returned non-200 status:', result.status);
                }
            } catch (error) {
                console.error('Error in checkSingleGoalInForecast:', error);
                // In case of error, allow edit/delete (fail-safe approach)
                const goalsData = (this.dictGoalSelected && Array.isArray(this.dictGoalSelected.data))
                    ? this.dictGoalSelected.data
                    : [];

                for (let i = 0; i < goalsData.length; i++) {
                    const goal = goalsData[i];
                    if (goal && goal.dict_program_goal_id === goalId) {
                        this.$set(goalsData[i], 'cannotDelete', false);
                        this.$set(goalsData[i], 'cannotEdit', false);
                        this.$set(goalsData[i], 'deletable', false);
                        this.$set(goalsData[i], 'editable', false);
                        break;
                    }
                }
            }
        },


        async deleteMeaningRow(el, indx) {
            const confirmed = await this.$bvModal.msgBoxConfirm(
                `Вы уверены, что хотите удалить НПА "${el.npa.name || el.npa.nameRu}"?`,
                {
                    title: 'Подтверждение удаления',
                    size: 'sm',
                    buttonSize: 'sm',
                    okVariant: 'danger',
                    okTitle: 'Удалить',
                    cancelTitle: 'Отмена',
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    centered: true
                }
            );

            if (!confirmed) {
                return;
            }

            try {
                let deleteUrl = `/api/program-passport/delete-program-passport-npa/${this.dictProgramPassportID}/${el.dict_npa_id}`;

                if (this.currentVariant && this.currentVariant.variantUUID) {
                    deleteUrl += `?variant=${encodeURIComponent(this.currentVariant.variantUUID)}`;
                }

                const response = await fetch(deleteUrl, {
                    method: 'DELETE',
                    headers: {
                        'Content-Type': 'application/json'
                    }
                });

                if (response.ok) {
                    const result = await response.json();
                    if (result === true) {
                        this.dictNpaSelectedList.data = this.removeRowByIndex(this.dictNpaSelectedList.data, indx);
                        this.makeToast('success', 'НПА удален', 'НПА успешно удален из базы данных');

                        this.initialArrNpa.delete(el.id);

                        this.$nextTick(() => {
                            this.emitUnsavedChangesStatus();
                        });
                    } else {
                        this.makeToast('danger', 'Ошибка удаления', 'Не удалось удалить НПА из базы данных');
                    }
                } else {
                    throw new Error(`HTTP ${response.status}: ${response.statusText}`);
                }

            } catch (error) {
                this.makeToast('danger', 'Ошибка удаления', `Произошла ошибка: ${error.message}`);
            }
        },

        async deleteGoalsRow(el, indx) {
            if (el.dict_program_goal_id) {
                await this.checkSingleGoalInForecast(el.dict_program_goal_id);
                await this.$nextTick();
            }

            const isCurrentVariantActual = this.currentVariant && this.currentVariant.actual === true;
            const updatedElement = this.dictGoalSelected.data[indx];
            const hasTargetIndicators = updatedElement.cannotDelete === true || updatedElement.deletable === true;

            if (hasTargetIndicators) {
                this.makeToast('danger', 'Внимание', 'Удаление цели программы невозможно при наличии по ней целевых индикаторов');
                return;
            }

            if (!isCurrentVariantActual) {
                this.makeToast('danger', 'Внимание', 'Удаление возможно только в актуальной версии программы');
                return;
            }

            const confirmed = await this.$bvModal.msgBoxConfirm(
                `Вы уверены, что хотите удалить цель "${el.goals.name || el.goals.name_ru}"?`,
                {
                    title: 'Подтверждение удаления',
                    size: 'sm',
                    buttonSize: 'sm',
                    okVariant: 'danger',
                    okTitle: 'Удалить',
                    cancelTitle: 'Отмена',
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    centered: true
                }
            );

            if (!confirmed) {
                return;
            }

            try {
                let deleteUrl = `/api/program-passport/delete-program-passport-goal/${this.dictProgramPassportID}/${el.dict_program_goal_id}`;

                if (this.currentVariant && this.currentVariant.variantUUID) {
                    deleteUrl += `?variant=${encodeURIComponent(this.currentVariant.variantUUID)}`;
                }

                const response = await fetch(deleteUrl, {
                    method: 'DELETE',
                    headers: {
                        'Content-Type': 'application/json'
                    }
                });

                if (response.ok) {
                    const result = await response.json();

                    if (result === true) {
                        this.dictGoalSelected.data = this.removeRowByIndex(this.dictGoalSelected.data, indx);
                        this.makeToast('success', 'Цель удалена', 'Цель успешно удалена из базы данных');

                        this.initialArrGoal.delete(el.id);

                        this.$nextTick(() => {
                            this.emitUnsavedChangesStatus();
                        });
                    } else {
                        this.makeToast('danger', 'Невозможно удалить', 'Удаление цели невозможно при наличии по ней целевых индикаторов');
                    }
                } else {
                    throw new Error(`HTTP ${response.status}: ${response.statusText}`);
                }

            } catch (error) {
                this.makeToast('danger', 'Ошибка удаления', `Произошла ошибка: ${error.message}`);
            }
        },

        cleanupUnsavedChanges() {
            this.dictNpaSelectedList.data = Array.from(this.initialArrNpa.values()).map(initial => ({
                ...JSON.parse(JSON.stringify(initial)),
                disabled: true,
                hasError: false
            }));

            this.dictGoalSelected.data = Array.from(this.initialArrGoal.values()).map(initial => ({
                ...JSON.parse(JSON.stringify(initial)),
                disabled: true,
                hasError: false
            }));

            this.$nextTick(() => {
                this.emitUnsavedChangesStatus();
            });
        },

        async closeAddEdit() {
            const hasRealChanges = this.hasUnsavedChanges();

            if (hasRealChanges) {
                const confirmed = await this.$bvModal.msgBoxConfirm(
                    'Внесенные изменения будут потеряны!',
                    {
                        title: 'Несохраненные изменения',
                        size: 'md',
                        buttonSize: 'sm',
                        okVariant: 'warning',
                        okTitle: 'Продолжить',
                        cancelTitle: 'Отмена',
                        footerClass: 'p-2',
                        hideHeaderClose: false,
                        centered: true
                    }
                );

                if (!confirmed) {
                    return;
                }

                this.cleanupUnsavedChanges();
            }

            this.edit = false;
            this.$emit('closePassport', this.edit);
        },

        //------Сравнение двух массивов
        compareTwoArrays(array1, array2) {
            let result = false;

            if (!array2 || !Array.isArray(array2)) {
                return false;
            }

            const cleanForComparison = (obj) => {
                const { deletable, editable, hasError, ...cleanObj } = obj;
                return cleanObj;
            };

            const equals = (a, b) => JSON.stringify(cleanForComparison(a)) === JSON.stringify(cleanForComparison(b));

            if (array1.size > 0 || array2.length > 0) {
                if (array1.size !== array2.length) {
                    return true;
                }
                for (const element of array2) {
                    if (element !== undefined) {
                        const initialObj = array1.get(element.id) !== undefined ? array1.get(element.id) : {};
                        if (!equals(element, initialObj)) {
                            result = true;
                        }
                    }
                }
            }
            return result;
        },

        async showDictNpaList(oblast, region) {
            const dateObj = new Date();
            const month = dateObj.getUTCMonth() + 1; //months from 1-12
            const day = dateObj.getUTCDate();
            const year = dateObj.getUTCFullYear();
            let mainReg = '';
            if (region.endsWith('0101')){
                mainReg = oblast;
            } else {
                mainReg = oblast+'0101';
            }
            // console.log('mainReg: ' + mainReg);

            let response = [];
            const result = [];
            // console.log('this.region: ' + region);
            try {
                response = await fetch('/api/dict/npa_list?year=' + year+'&month=' + month + '&day='+ day + '&region=' + region + '&oblast=' + mainReg);
                response = await response.json();

                const npaData = Array.isArray(response) ? response : [];

                if (npaData.length > 0) {
                    for (const el of npaData){
                        result.push(this.setNameLangs(el, 'npa'));
                    }
                }
                this.dictNpaList = result;
            } catch (error) {
                this.makeToast('danger', 'Ошибка загрузки DictNPA', error.toString());
            }
        },

        async showDictProgramGoalsList(){
            let response = [];
            try {
                response = await fetch('/api/dict/get-goals');
                response = await response.json();
                const goalsData = Array.isArray(response) ? response : [];

                if (goalsData.length > 0){
                    for (const el of goalsData) {
                        this.dictProgramPassportGoals.push(this.setNameLangs(el, 'goals'));
                    }
                }
            } catch (error) {
                this.makeToast('danger', 'Ошибка загрузки DictProgramGoals', error.toString());
            }
        },

        hasUnsavedChanges() {
            try {
                const npaData = (this.dictNpaSelectedList && Array.isArray(this.dictNpaSelectedList.data))
                    ? this.dictNpaSelectedList.data
                    : [];
                const goalData = (this.dictGoalSelected && Array.isArray(this.dictGoalSelected.data))
                    ? this.dictGoalSelected.data
                    : [];

                const hasUnsavedNpas = npaData.some(npa => {
                    const isEmptyUnsaved = !npa.npa && !npa.disabled;
                    const isFilledUnsaved = npa.npa && !npa.disabled;
                    return isEmptyUnsaved || isFilledUnsaved;
                });

                const hasModifiedNpas = this.compareTwoArrays(this.initialArrNpa, npaData);

                const hasUnsavedGoals = goalData.some(goal => {
                    const isEmptyUnsaved = !goal.goals && !goal.disabled;
                    const isFilledUnsaved = goal.goals && !goal.disabled;
                    return isEmptyUnsaved || isFilledUnsaved;
                });

                const validGoals = goalData.filter(goal =>
                    goal.goals &&
                    goal.dict_program_goal_id &&
                    goal.dict_program_goal_id !== '' &&
                    Object.keys(goal.goals).length > 0
                );

                const hasModifiedGoals = this.compareTwoArrays(this.initialArrGoal, validGoals);

                return hasUnsavedNpas || hasModifiedNpas || hasUnsavedGoals || hasModifiedGoals;
            } catch (error) {
                console.error('Error in hasUnsavedChanges:', error);
                return false;
            }
        },

        async save() {
            if (!this.currentVariant || !this.currentVariant.variantUUID) {
                this.makeToast('danger', 'Ошибка сохранения', 'Не определена версия программы. Попробуйте изменить дату фильтра.');
                return;
            }

            const hadUnsavedChanges = this.hasUnsavedChanges();
            const npaLists = this.compareTwoArrays(this.initialArrNpa, this.dictNpaSelectedList.data);
            const goalsLists = this.compareTwoArrays(this.initialArrGoal, this.dictGoalSelected.data);

            let hasEmptyNpas = false;
            let hasEmptyGoals = false;
            let npasSaved = false;
            let goalsSaved = false;

            if (this.dictNpaSelectedList.data.length > 0 && npaLists) {
                const npaArr = [];

                for (let i = 0; i < this.dictNpaSelectedList.data.length; i++) {
                    const npa = this.dictNpaSelectedList.data[i];

                    if (!npa.npa || Object.keys(npa.npa).length === 0) {
                        hasEmptyNpas = true;
                        this.$set(this.dictNpaSelectedList.data[i], 'hasError', true);
                    } else {
                        this.$set(this.dictNpaSelectedList.data[i], 'hasError', false);
                        npaArr.push(npa.dict_npa_id);
                    }
                }

                if (hasEmptyNpas) {
                    this.makeToast('danger', 'Незаполненные поля', 'Заполните все поля НПА или удалите пустые записи');
                    return;
                }

                if (npaArr.length > 0) {
                    npasSaved = await this.saveNpaDataToDB(npaArr);
                }
            }

            if (this.dictGoalSelected.data.length > 0 && goalsLists) {
                const goalsArr = [];
                const validGoals = this.dictGoalSelected.data.filter(goal =>
                    goal.goals &&
                    goal.dict_program_goal_id &&
                    goal.dict_program_goal_id !== '' &&
                    Object.keys(goal.goals).length > 0
                );

                for (let i = 0; i < this.dictGoalSelected.data.length; i++) {
                    const goal = this.dictGoalSelected.data[i];

                    if (!goal.goals || !goal.dict_program_goal_id || goal.dict_program_goal_id === '' || Object.keys(goal.goals).length === 0) {
                        hasEmptyGoals = true;
                        this.$set(this.dictGoalSelected.data[i], 'hasError', true);
                    } else {
                        this.$set(this.dictGoalSelected.data[i], 'hasError', false);
                        goalsArr.push(goal.dict_program_goal_id);
                    }
                }

                if (hasEmptyGoals) {
                    this.makeToast('danger', 'Не все поля заполнены', 'Заполните все поля целей или удалите пустые записи');
                    return;
                }

                if (goalsArr.length > 0) {
                    goalsSaved = await this.saveGoalDataToDB(goalsArr);
                }
            }

            if (npasSaved || !npaLists) {
                this.dictNpaSelectedList.data.forEach(npa => {
                    if (npa.npa && npa.dict_npa_id) {
                        npa.disabled = true;
                        npa.hasError = false;
                    }
                });

                this.initialArrNpa.clear();
                this.dictNpaSelectedList.data.forEach(npa => {
                    if (npa.npa && npa.dict_npa_id) {
                        this.initialArrNpa.set(npa.id, JSON.parse(JSON.stringify(npa)));
                    }
                });
            }

            if (goalsSaved || !goalsLists) {
                this.dictGoalSelected.data.forEach(goal => {
                    if (goal.goals && goal.dict_program_goal_id) {
                        goal.disabled = true;
                        goal.hasError = false;
                    }
                });

                this.initialArrGoal.clear();
                this.dictGoalSelected.data.forEach(goal => {
                    if (goal.goals && goal.dict_program_goal_id) {
                        this.initialArrGoal.set(goal.id, JSON.parse(JSON.stringify(goal)));
                    }
                });
            }

            this.$nextTick(() => {
                this.emitUnsavedChangesStatus();

                if (hadUnsavedChanges && !this.hasUnsavedChanges()) {
                    this.removeBrowserNavigationProtection();
                    this.addBrowserNavigationProtection();
                }
            });
        },

        //-----Сохранить данные в БД (program_passport_npa)
        async saveNpaDataToDB(arr) {
            try {
                if (arr.length > 0) {
                    const headers = {
                        'Content-Type': 'application/json'
                    };

                    let url = `/api/program-passport/add-program-passport-npa/${this.dictProgramPassportID}`;
                    if (this.currentVariant && this.currentVariant.variantUUID) {
                        url += `?variant=${encodeURIComponent(this.currentVariant.variantUUID)}`;
                    }

                    const result = await axios.post(url, arr, {headers});
                    if (result.status === 200 && result.data === true) {
                        this.makeToast('success', 'Сохранение оснований для разработки', 'Данные сохранены!');
                        return true;
                    } else {
                        this.makeToast('danger', 'Сохранение оснований для разработки', `Ошибка ${result.status} ${result.statusText}`);
                        return false;
                    }
                }
            } catch (error) {
                console.error(error);
                this.makeToast('danger', 'Сохранение оснований для разработки', 'Произошла ошибка при сохранении');
                return false;
            }
        },

        //-----Сохранить данные в БД (program_passport_goal)
        async saveGoalDataToDB(arr) {
            try {
                if (arr.length > 0) {
                    const headers = {
                        'Content-Type': 'application/json'
                    };

                    let url = `/api/program-passport/add-program-passport-goal/${this.dictProgramPassportID}`;
                    if (this.currentVariant && this.currentVariant.variantUUID) {
                        url += `?variant=${encodeURIComponent(this.currentVariant.variantUUID)}`;
                    }

                    const result = await axios.post(url, arr, {headers});

                    if (result.status === 200) {
                        // Check if the response indicates success
                        if (result.data === true || result.data === 'true' || result.data?.success === true) {
                            this.makeToast('success', 'Сохранение целей', 'Данные сохранены!');
                            return true;
                        } else if (typeof result.data === 'object' && result.data !== null) {
                            // If we get an object response, it might still be successful
                            this.makeToast('success', 'Сохранение целей', 'Данные сохранены!');
                            return true;
                        } else {
                            console.warn('Unexpected response format:', result.data);
                            this.makeToast('warning', 'Сохранение целей', 'Данные могли быть сохранены. Обновите страницу для проверки.');
                            return true; // Assume success since status is 200
                        }
                    } else {
                        this.makeToast('danger', 'Сохранение целей', `Ошибка ${result.status} ${result.statusText}`);
                        return false;
                    }
                }
                return false;
            } catch (error) {
                console.error('Goals save error:', error);

                // Check if it's a network error or server error
                if (error.response) {
                    // Server responded with error status
                    this.makeToast('danger', 'Сохранение целей', `Ошибка сервера: ${error.response.status}`);
                } else if (error.request) {
                    // Network error
                    this.makeToast('danger', 'Сохранение целей', 'Ошибка сети. Проверьте соединение.');
                } else {
                    // Other error
                    this.makeToast('danger', 'Сохранение целей', 'Произошла неизвестная ошибка');
                }
                return false;
            }
        },

        // ----Создание объектов на основе переданных данных из справочников----//
        setNameLangs(obj, codeName) {
            // let txt = obj['name_' + this.$i18n.locale];
            let txt = '';
            if (codeName === 'npa') {
                txt = obj.nameRu;
            } else {
                txt = obj.name_ru;
            }
            if (txt !== undefined) {
                if (codeName !== undefined && codeName !== null && obj[codeName] !== undefined) {
                    txt = obj[codeName] + ' - ' + txt;
                    // console.log('txt: ' + txt);
                }
            }
            const el = Object.assign({}, obj);
            el.name = txt;
            return el;
        },

        // ------Метод для отображения сообщения с ошибками----//
        makeToast(variant, title, tostbody) {
            this.$bvToast.toast(tostbody, {
                title: title,
                autoHideDelay: 5000,
                variant: variant,
                appendToast: true
            });
        }, // сообщение с ошибкой

        async onDateChanged(newDate) {
            this.loading = true;
            this.selectedDate = newDate;
            this.$emit('dateChanged', newDate);

            try {
                await this.calculateProgramVariant(newDate);

                await this.getPrgPassportNpaAndGoals(this.dictProgramPassportID);
            } catch (error) {
                console.error('Error handling date change:', error);
                this.makeToast('danger', 'Ошибка', 'Произошла ошибка при изменении даты');
            } finally {
                this.loading = false;
            }
        },

        getSelectedDate() {
            return this.$refs.dateFilter ? this.$refs.dateFilter.getSelectedDate() : null;
        }

    },
    computed: {
        //------Замена массива для отображения в "<multiselect>" ранее сохраненных значений в БД
        optionForValue() {
            const map = Object.create(null)
            if (!Array.isArray(this.dictNpaList)) {
                return map;
            }
            for (const option of this.dictNpaList) {
                map[option.id] = option
            }
            return map
        },
        userAccessLevel() {
            return this.$store.getters.getUserModuleAccess('003.005');
        },
        isReadOnlyMode() {
            let isReadOnly = false;

            if (this.userAccessLevel === 1) {
                isReadOnly = true;
            }

            if (this.currentVariant && this.currentVariant.actual === false) {
                isReadOnly = true;
            }

            if (this.currentProgramPassport && this.currentProgramPassport.endDate) {
                const programEndDate = new Date(this.currentProgramPassport.endDate);
                const currentDate = new Date();
                currentDate.setHours(0, 0, 0, 0);

                if (programEndDate < currentDate) {
                    isReadOnly = true;
                }
            }

            return isReadOnly;
        },
        availableGoalOptions() {
            return (index) => {
                const selectedIds = this.dictGoalSelected.data
                    .filter((_, i) => i !== index)
                    .map(goal => goal.dict_program_goal_id)
                    .filter(id => id && id !== '');

                return this.dictProgramPassportGoals.filter(goal => !selectedIds.includes(goal.id));
            };
        },
        dictNpaArr() {
            try {
                if (!this.dictNpaSelectedList || !Array.isArray(this.dictNpaSelectedList.data)) {
                    return [];
                }

                const dictNpaList = this.optionForValue;
                return this.dictNpaSelectedList.data.map(npaElement => {
                    return {
                        ...npaElement,
                        get npa() {
                            return dictNpaList[npaElement.dict_npa_id];
                        },
                        set npa(option) {
                            npaElement.dict_npa_id = option.id;
                        }
                    }
                });
            } catch (error) {
                console.error('[ERROR in dictNpaArr]:', error);
                return [];
            }
        },

        dictGoalsArr() {
            try {
                if (!this.dictGoalSelected || !Array.isArray(this.dictGoalSelected.data)) {
                    return [];
                }

                const dictProgramPassportGoals = this.optionGoalForValue;
                return this.dictGoalSelected.data.map(goalElement => {
                    return {
                        ...goalElement,
                        get goals() {
                            return dictProgramPassportGoals[goalElement.dict_program_goal_id];
                        },
                        set goals(option) {
                            if (option && option.id) {
                                goalElement.dict_program_goal_id = option.id;
                            }
                        }
                    }
                });
            } catch (error) {
                console.error('[ERROR in dictGoalsArr]:', error);
                return [];
            }
        },
        optionGoalForValue() {
            const map = Object.create(null)
            if (!Array.isArray(this.dictProgramPassportGoals)) {
                return map;
            }
            for (const option of this.dictProgramPassportGoals) {
                map[option.id] = option
            }
            return map
        },
        programPassportName(){
            return this.currentProgramPassport.nameRu;
        },
        programPassportDates(){
            const startDate = new Date(this.currentProgramPassport.startDate).getFullYear();
            const endDate = new Date(this.currentProgramPassport.endDate).getFullYear();
            return startDate + ' - ' + endDate;
        },
        isProgramPassportExpired() {
            if (this.currentProgramPassport && this.currentProgramPassport.expired) {
                return true;
            }

            if (!this.currentVariant) {
                return true;
            }

            if (this.currentVariant.actual === true) {
                return false;
            }

            if (this.currentVariant.actual === false) {
                return true;
            }

            return true;
        },
        userId() {
            return this.$store.getters.user_uuid;
        },

        programStartDate() {
            if (this.currentProgramPassport && this.currentProgramPassport.startDate) {
                return new Date(this.currentProgramPassport.startDate).toISOString().split('T')[0];
            }
            return null;
        },

        programEndDate() {
            if (this.currentProgramPassport && this.currentProgramPassport.endDate) {
                return new Date(this.currentProgramPassport.endDate).toISOString().split('T')[0];
            }
            return null;
        }
    }

}
</script>

<!-- REPLACE YOUR ENTIRE <style scoped> SECTION WITH THIS -->
<style scoped>
/* ============================================
   MULTISELECT DROPDOWN FIXES
   ============================================ */

/* Fix dropdown height and scrolling */
.table-style .multiselect ::v-deep .multiselect__content-wrapper {
    max-height: 240px !important;  /* Reduced from 300px */
    overflow-y: auto !important;
    overflow-x: hidden !important;
    position: absolute !important;
    width: 100% !important;
    z-index: 50 !important;
    border: 1px solid #e0e0e0 !important;
    border-top: none !important;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1) !important;
    background: white !important;
}

/* Fix option height for text wrapping with better spacing */
.table-style .multiselect ::v-deep .multiselect__option {
    height: auto !important;
    min-height: 35px !important;  /* Reduced from 40px */
    white-space: normal !important;
    word-wrap: break-word !important;
    word-break: break-word !important;
    padding: 8px 12px !important;  /* Reduced padding */
    line-height: 1.3 !important;
    display: block !important;
    overflow: visible !important;
    font-size: 14px !important;
    border-bottom: 1px solid #f5f5f5 !important;
}

/* Remove border from last option */
.table-style .multiselect ::v-deep .multiselect__option:last-child {
    border-bottom: none !important;
}

/* Multiselect element */
.table-style .multiselect ::v-deep .multiselect__element {
    height: auto !important;
}

/* Content container */
.table-style .multiselect ::v-deep .multiselect__content {
    display: inline-block !important;
    overflow: visible !important;
    width: 100% !important;
}

/* Selected value display */
.table-style .multiselect ::v-deep .multiselect__single {
    white-space: normal !important;
    word-wrap: break-word !important;
    overflow: visible !important;
    display: block !important;
    padding-right: 5px !important;
    line-height: 1.3 !important;
    font-size: 14px !important;
}

/* Tags container */
.table-style .multiselect ::v-deep .multiselect__tags {
    min-height: 38px !important;  /* Slightly reduced */
    padding: 6px 40px 6px 8px !important;
    white-space: normal !important;
    border: 1px solid #ced4da !important;
    border-radius: 4px !important;
}

/* ============================================
   TABLE LAYOUT - COMPACT DESIGN
   ============================================ */

.table-style {
    display: flex;
    position: relative;
    min-height: 40px;
}

.table-style .w-50 {
    width: 35px !important;  /* Reduced width */
    min-width: 35px !important;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    color: #6c757d;
}

.table-style .full {
    flex: 1;
    position: relative;
}

/* Dropdown actions column */
.table-style .w-50:last-child {
    width: 40px !important;
    min-width: 40px !important;
}

/* ============================================
   CONTAINER ADJUSTMENTS
   ============================================ */

.form-card {
    overflow: visible !important;
    background: white;
    border-radius: 8px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.initial-form-passport {
    overflow: visible !important;
}

.passport-item {
    overflow: visible !important;
    border-bottom: 1px solid #f0f0f0;
}

.passport-item:last-child {
    border-bottom: none;
}

.passport-item .content {
    overflow: visible !important;
}

.passport-item .table-content {
    overflow: visible !important;
    position: relative;
    padding: 5px 0;
}

/* ============================================
   TITLE STYLING
   ============================================ */

.passport-item .title {
    font-weight: 600;
    color: #495057;
    font-size: 15px;
}

.passport-item .content.once {
    margin-bottom: 0;
}

.passport-item.h-60 {
    min-height: 60px;
}

/* ============================================
   ERROR STATES - MORE SUBTLE
   ============================================ */

.has-error {
    background-color: #fff5f5 !important;
    border-radius: 4px;
}

.error-field ::v-deep .multiselect__tags {
    border-color: #dc3545 !important;
    background-color: #fff5f5 !important;
}

/* ============================================
   HOVER AND SELECTED STATES
   ============================================ */

.table-style .multiselect ::v-deep .multiselect__option--highlight {
    background: #f8f9fa !important;
    color: #495057 !important;
}

.table-style .multiselect ::v-deep .multiselect__option--selected {
    background: #e7f3ff !important;
    color: #0066cc !important;
    font-weight: 500 !important;
}

.table-style .multiselect ::v-deep .multiselect__option--selected.multiselect__option--highlight {
    background: #d4e8ff !important;
    color: #0052a3 !important;
}

/* ============================================
   CUSTOM TEMPLATE STYLES
   ============================================ */

.multiselect-single-content {
    white-space: normal !important;
    word-wrap: break-word !important;
    line-height: 1.3 !important;
    display: block !important;
    font-size: 14px !important;
}

.multiselect-option-content {
    white-space: normal !important;
    word-wrap: break-word !important;
    word-break: break-word !important;
    line-height: 1.3 !important;
    display: block !important;
    width: 100% !important;
    font-size: 14px !important;
}

/* ============================================
   ADD LINK STYLES - COMPACT
   ============================================ */

.add-link {
    display: inline-flex;
    align-items: center;
    color: #007bff;
    text-decoration: none;
    cursor: pointer;
    transition: color 0.2s;
    font-size: 14px;
}

.add-link:hover {
    color: #0056b3;
    text-decoration: none;
}

.add-link.disabled {
    opacity: 0.5;
    pointer-events: none;
    cursor: not-allowed;
}

.add-button {
    margin-right: 6px;
    font-size: 16px;
}

/* ============================================
   DISABLED STATES
   ============================================ */

.table-style .multiselect ::v-deep .multiselect--disabled {
    background-color: #f8f9fa;
    opacity: 0.8;
}

.table-style .multiselect ::v-deep .multiselect--disabled .multiselect__tags {
    background-color: #f8f9fa;
    border-color: #dee2e6;
}

/* ============================================
   SCROLLBAR STYLING - THINNER
   ============================================ */

.table-style .multiselect ::v-deep .multiselect__content-wrapper::-webkit-scrollbar {
    width: 6px;
}

.table-style .multiselect ::v-deep .multiselect__content-wrapper::-webkit-scrollbar-track {
    background: #f8f9fa;
    border-radius: 3px;
}

.table-style .multiselect ::v-deep .multiselect__content-wrapper::-webkit-scrollbar-thumb {
    background: #adb5bd;
    border-radius: 3px;
}

.table-style .multiselect ::v-deep .multiselect__content-wrapper::-webkit-scrollbar-thumb:hover {
    background: #868e96;
}

/* ============================================
   FILTER CONTAINER STYLES
   ============================================ */

.filter-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    padding: 12px 15px;
    background: #f8f9fa;
    border-radius: 6px;
}

.left-content {
    display: flex;
    align-items: center;
}

.right-content {
    display: flex;
    align-items: center;
}

.filter-actions {
    display: flex;
    gap: 10px;
}

/* ============================================
   DROPDOWN BUTTON STYLES
   ============================================ */

.table-style .more {
    margin-left: 0;
}

.table-style .more ::v-deep .btn {
    padding: 4px 8px !important;
    font-size: 18px !important;
    line-height: 1 !important;
}

/* ============================================
   ACTIVE DROPDOWN Z-INDEX
   ============================================ */

.table-style .multiselect ::v-deep .multiselect--active {
    z-index: 50 !important;
}

.table-style .multiselect ::v-deep .multiselect--active .multiselect__content-wrapper {
    z-index: 51 !important;
}

/* ============================================
   PLACEHOLDER STYLING
   ============================================ */

.table-style .multiselect ::v-deep .multiselect__placeholder {
    color: #6c757d;
    padding-top: 0;
    padding-left: 0;
    margin-bottom: 0;
    font-size: 14px;
}

/* ============================================
   INPUT FIELD STYLING
   ============================================ */

.table-style .multiselect ::v-deep .multiselect__input {
    font-size: 14px !important;
    padding: 0 !important;
    margin-bottom: 5px !important;
}

/* ============================================
   RESPONSIVE ADJUSTMENTS
   ============================================ */

@media (max-width: 768px) {
    .table-style .multiselect ::v-deep .multiselect__content-wrapper {
        max-height: 180px !important;
    }

    .filter-container {
        flex-direction: column;
        align-items: stretch;
    }

    .right-content {
        margin-top: 10px;
    }

    .passport-item .title {
        font-size: 14px;
    }
}
</style>
